var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSettingIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_13931",
    "data-name": "Group 13931",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 31.84,
    height: 31.84,
    viewBox: "0 0 31.84 31.84",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5129",
    "data-name": "Rectangle 5129",
    width: 31.84,
    height: 31.84,
    fill: "#111"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13246",
    "data-name": "Group 13246",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_45503",
    "data-name": "Path 45503",
    d: "M17.874,0c1.972.541,1.51,2.671,1.9,4.228l1.732.716c1.389-.849,2.777-2.891,4.533-1.47a21.122,21.122,0,0,1,2.622,2.778c.723,1.7-.965,2.772-1.758,4.046l.71,1.769c1.562.392,3.684-.08,4.228,1.9v3.848c-.555,1.975-2.665,1.509-4.228,1.9L26.9,21.446c.841,1.371,2.861,2.759,1.5,4.5a23.758,23.758,0,0,1-2.424,2.418c-1.691,1.3-3.122-.67-4.431-1.523l-1.769.71c-.36,1.5.026,4.045-2.114,4.23a25.682,25.682,0,0,1-3.418,0c-2.1-.182-1.8-2.718-2.088-4.212l-1.723-.727c-1.39.738-2.609,2.757-4.393,1.6a24.462,24.462,0,0,1-2.562-2.528c-1.279-1.665.6-3.082,1.481-4.356L5,21.41l-.727-1.723C2.813,19.4.266,19.7.06,17.659A24.058,24.058,0,0,1,.087,13.9a2.1,2.1,0,0,1,1.573-1.469c.349-.075,2.55-.257,2.628-.364L5,10.3C4.147,8.986,2.17,7.565,3.475,5.867A23.737,23.737,0,0,1,6.267,3.2C8,2.406,9.078,4.182,10.394,4.944l1.732-.716c.392-1.562-.08-3.684,1.9-4.228Zm-2.62,9.33a6.6,6.6,0,1,0,6.376,9.914A6.62,6.62,0,0,0,15.255,9.33",
    transform: "translate(0)",
    fill: "#111"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingIcon);
export default __webpack_public_path__ + "static/media/setting_icon.fb069fd33f577ca33b4883750e846b93.svg";
export { ForwardRef as ReactComponent };